export const callhistorydata = [
  {
    checkbox: true,
    name: "Anthony Lewis",
    text:"anthony@example.com",
    phone_number: "(123) 4567 890",
    call_type: "Incoming",
    duration: "00.25",
    date_time: "14/01/2024, 04:27 AM ",
    image_url: "assets/img/users/user-32.jpg",
    icon:"phone-incoming",
    key: "1"
  },
  {
    checkbox: true,
    name: "Brian Villalobos",
    text:"brian@example.com",
    phone_number: "(179) 7382 829",
    call_type: "Outgoing",
    duration: "00.10",
    date_time: "21/01/2024, 03:19 AM",
    image_url: "assets/img/users/user-09.jpg",
    icon:"phone-outgoing",
    key: "2"
  },
  {
    checkbox: true,
    name: "Harvey Smith",
    text:"harvey@example.com",
    phone_number: "(184) 2719 738",
    call_type: "Incoming",
    duration: "00.40",
    date_time: "20/02/2024, 12:15 PM",
    image_url: "assets/img/users/user-01.jpg",
    icon:"video",
    key: "3"
  },
  {
    checkbox: true,
    name: "peral@example.com",
    text:"peral@example.com",
    phone_number: "(193) 7839 748",
    call_type: "Missed Call",
    duration: "00.00",
    date_time: "15/03/2024, 12:11 AM",
    image_url: "assets/img/users/user-33.jpg",
    icon:"phone-x",
    key: "4"
  },
  {
    checkbox: true,
    name: "Doglas Martini",
    text:"martniwr@example.com",
    phone_number: "(183) 9302 890",
    call_type: "Outgoing",
    duration: "00.35",
    date_time: "12/04/2024, 05:48 PM",
    image_url: "assets/img/users/user-33.jpg",
    icon:"video",
    key: "5"
  },
  {
    checkbox: true,
    name: "Linda Ray",
    text:"ray456@example.com",
    phone_number: "(120) 3728 039",
    call_type: "Incomiing",
    duration: "01.40",
    date_time: "20/05/2024, 06:11 PM",
    image_url: "assets/img/users/user-02.jpg",
    icon:"phone-incoming",
    key: "6"
  },
  {
    checkbox: true,
    name: "Elliot Murray",
    text:"murray@example.com",
    phone_number: "(102) 8480 832",
    call_type: "Missed call",
    duration: "00.00",
    date_time: "06/07/2024, 07:15 PM",
    image_url: "assets/img/users/user-35.jpg",
    icon:"video",
    key: "7"
  },
  {
    checkbox: true,
    name: "Rebecca Smtih",
    text:"smtih@example.com",
    phone_number: "(162) 8920 713",
    call_type: "Outgoing",
    duration: "00.45",
    date_time: "02/09/2024, 09:21 PM",
    image_url: "assets/img/users/user-36.jpg",
    icon:"phone-outgoing",
    key: "8"
  },
  {
    checkbox: true,
    name: "Connie Waters",
    text:"connie@example.com",
    phone_number: "(189) 0920 723",
    call_type: "Incoming",
    duration: "00.50",
    date_time: "15/11/2024, 12:44 PM",
    image_url: "assets/img/users/user-37.jpg",
    icon:"phone-outgoing",
    key: "9"
  },
  {
    checkbox: true,
    name: "Lori Broaddus",
    text:"broaddus@example.com",
    phone_number: "(168) 8392 823",
    call_type: "Missed call",
    duration: "00.00",
    date_time: "10/12/2024, 11:23 PM",
    image_url: "assets/img/users/user-38.jpg",
    icon:"phone-x ",
    key: "10"
  },
];
